import { classeColorePerc } from "../inc/inc";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

export default function Comp(props) {
  let percentOkDisplay =
    !props.percentualeOk || props.percentualeOk < 8 ? 8 : props.percentualeOk;
  // let percentNoDisplay = (!props.percentualeNo ||  props.percentualeNo < 8) ? 8 : props.percentualeNo;

  return (
    <div className="graficoPDF noBreak">
      <div style={{ display: "flex", alignItems: "stretch" }}>
        <div className="boxSottoSezioni" style={{ width: "50%" }}>
          <h2 style={{ marginTop: 0}}>
            {props.nomeSezione}
          </h2>
          <b
            className="maiuscF"
            style={{
              paddingLeft: 15,
            }}
          >
            Contenuti:
          </b>
          <ul>
            {props.sottoSezioni &&
              props.sottoSezioni.map((el, index) => {
                return <li key={index}>{el}</li>;
              })}
          </ul>
        </div>
        <div style={{ width: "50%" }}>
          <p className="maiuscF">
            Domande Totali: <b>{props.questionsTot}</b> - Risposte:{" "}
            <b>{props.rispTot}</b>
          </p>
          <p
            style={{ display: "flex", alignItems: "center" }}
            className="maiuscF"
          >
            Conformità Campione:{" "}
            {props.conforme ? (
              <CheckIcon color="success" />
            ) : (
              <CloseIcon color="error" />
            )}
          </p>
          <div className="elemGrafico">
            <div
              className="innerGrafico"
              style={{
                backgroundColor: props.colore,
                width: percentOkDisplay + "%",
              }}
            ></div>
          </div>
          <div
            className={"percentuale " + classeColorePerc(props.percentualeOk)}
            style={{ minWidth: "150px", textAlign: "center", marginTop: 15 }}
          >
            {(props.percentualeOk || 0) + "%"}
          </div>
        </div>
      </div>
    </div>
  );
}
